export default function (Vue) {
    Vue.directive('focus', {
        inserted: function (el) {
            el.focus();
        }
    });

    Vue.directive('require', {
        inserted: function (el, binding) {
            el.required = true;
            el.parentElement.setAttribute('data-error', binding.value);
            const errorClass = 'field_with_errors';

            el.addEventListener('focus', function() {
                el.parentElement.classList.remove(errorClass);
            });

            el.addEventListener('invalid', function(event) {
                event.preventDefault();
                el.parentElement.classList.add(errorClass);
            });
        }
    });

    Vue.directive('expand', {
        inserted: function (el, binding) {
            el.addEventListener('click', function() {

                el.parentNode.removeChild(el);
                var elems = document.querySelectorAll(binding.value);

                elems.forEach(function(elem) {
                    elem.classList.toggle('expanded');
                });
            });
        }
    });

		// https://stackoverflow.com/a/60147946/15850452
		Vue.directive('click-outside', {
			bind: function (element, binding, vnode) {
				element.clickOutsideEvent = function (event) {  //  check that click was outside the el and his children
					if (!(element === event.target || element.contains(event.target))) { // and if it did, call method provided in attribute value
						vnode.context[binding.expression](event);
					}
				};
				document.body.addEventListener('click', element.clickOutsideEvent)
			},
			unbind: function (element) {
				document.body.removeEventListener('click', element.clickOutsideEvent)
			}
		});		
}
